export const ROUTE_CATEGORIES = {
  OPTIMIZATION_CREATED: 'Optimization created route',
  MANUALLY_CREATED: 'Manually created route',
  MANUALLY_ADJUSTED: 'Manually adjusted route',
  SEQUENCE_OPTIMIZER: 'Sequence optimizer route',
  SYSTEM_CREATED: 'System created route'
} as const;

export const KPI_LABELS = {
  DYNAMIC_OPTIMIZER_RUNS: 'Dynamic Optimizer Runs',
  SEQUENCE_OPTIMIZER_RUNS: 'Sequence Optimizer Runs',
  OPTIMIZATION_CREATED_ROUTES: 'Optimization Created Routes',
  MANUALLY_ADJUSTED_ROUTES: 'Manually Adjusted Routes',
  MANUALLY_CREATED_ROUTES: 'Manually Created Routes',
  SYSTEM_CREATED_ROUTES: 'System Created Routes'
} as const;

export const DRAWER_WIDTH = 480;

// Above MUI Dialog default z-index (1300) when filter popupParent is document.body
export const FILTER_POPUP_Z_INDEX = '1500';

export const TIMELINE_METRIC_LABELS = {
  STOP_SEQUENCE: 'Stop Seq',
  TTL_BILLS: 'Ttl Bills',
  STOPS: 'Stops',
  TTL_TIME: 'Ttl Time',
  ANCHOR_POINT: 'Anchor Point',
  ROUTE_TYPE: 'Route Type'
} as const;
